import { render, staticRenderFns } from "./ReviewModals.vue?vue&type=template&id=c0031b6c&"
import script from "./ReviewModals.vue?vue&type=script&lang=js&"
export * from "./ReviewModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports